import { assertBadHttpStatus } from './assert';
import { fetchGetOffersByLayoutMobile } from '../shared/repositories/newbuilding-card/v1/get-offers-by-layout-mobile';
import { assertNotFoundResponse } from './assert/assertNotFoundResponse';
export async function fetchLayoutsOffers(_ref) {
  let {
    params,
    httpApi,
    logger
  } = _ref;
  try {
    const response = await fetchGetOffersByLayoutMobile({
      httpApi,
      parameters: params,
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']]
        }
      }
    });
    assertBadHttpStatus(response);
    assertNotFoundResponse(response);
    return response.response.layout || null;
  } catch (error) {
    logger.error(error, {
      domain: 'src/services/fetchLayoutsOffers'
    });
    return null;
  }
}